import { keysFromItems } from '../helpers/keysFromItems.js';

function everything() {
  return (items) => {
    const keys = keysFromItems(items);
    return keys;
  };
}

export { everything };
//# sourceMappingURL=everything.js.map
